(function () {
  'use strict';

  const LOAD_THRESHOLD = 1500;
  let isLoading = false;
  let noMorePages = false;
  let sentinel = null;
  let observer = null;

  function getNextPageUrl() {
    const nextLink = document.querySelector('.pagination__item.push-btn.ml-auto') || document.querySelector('a[rel="next"]');
    return nextLink && nextLink.href ? nextLink.href : null;
  }

  function getProductGrid() {
    const facetsResults = document.getElementById('facets-results');
    if (facetsResults) {
      const ul = facetsResults.querySelector('ul');
      if (ul) return ul;
    }
    return document.querySelector('ul.grid');
  }

  // Loader und Sentinel in einen gemeinsamen Container packen, um DOM-Konflikte zu vermeiden
  function setupContainer() {
    const grid = getProductGrid();
    if (!grid || !grid.parentNode) return;

    let container = document.getElementById('infinite-scroll-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'infinite-scroll-container';
      container.style.cssText = 'width:100%;display:flex;flex-direction:column;align-items:center;padding:2rem 0;';
      
      container.innerHTML = `
        <div id="infinite-scroll-loader" style="display:none;text-align:center;margin-bottom:1rem;">
          <span style="
            display:inline-block;width:36px;height:36px;
            border:3px solid rgba(0,0,0,0.1);
            border-top-color:#333;border-radius:50%;
            animation:is-spin 0.8s linear infinite;
          "></span>
          <style>@keyframes is-spin{to{transform:rotate(360deg)}}</style>
        </div>
        <div id="infinite-scroll-sentinel" style="height:1px;width:100%;"></div>
      `;

      grid.parentNode.insertBefore(container, grid.nextSibling);
    }
    
    sentinel = document.getElementById('infinite-scroll-sentinel');
  }

  function showLoader() {
    const loader = document.getElementById('infinite-scroll-loader');
    if (loader) loader.style.display = 'block';
  }

  function hideLoader() {
    const loader = document.getElementById('infinite-scroll-loader');
    if (loader) loader.style.display = 'none';
  }

  function hidePagination() {
    const pagination = document.querySelector('nav.pagination');
    if (pagination) pagination.style.visibility = 'hidden';
  }

  // Bilder im Hintergrund vorladen, bevor sie ins DOM gerendert werden
  async function preloadImages(containerElement) {
    const images = containerElement.querySelectorAll('img');
    const promises = Array.from(images).map(img => {
      return new Promise((resolve) => {
        const src = img.dataset.src || img.src;
        if (!src) { resolve(); return; }
        const tempImage = new Image();
        tempImage.src = src;
        tempImage.onload = resolve;
        tempImage.onerror = resolve; // Auch bei Fehlern fortfahren, damit es nicht blockiert
      });
    });
    await Promise.all(promises);
  }

  async function loadNextPage() {
    if (isLoading || noMorePages) return;
    const nextUrl = getNextPageUrl();
    if (!nextUrl) { 
      noMorePages = true; 
      if (observer) observer.disconnect(); 
      return; 
    }

    isLoading = true;
    showLoader();

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Fetch failed: ' + response.status);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const currentGrid = getProductGrid();
      let newGrid = null;
      const newFacets = doc.getElementById('facets-results');
      if (newFacets) newGrid = newFacets.querySelector('ul');
      if (!newGrid) newGrid = doc.querySelector('ul.grid');

      if (newGrid && currentGrid) {
        const fragment = document.createDocumentFragment();
        Array.from(newGrid.children).forEach(item => {
          fragment.appendChild(item.cloneNode(true));
        });

        // 1. Bilder vorab laden, während sie noch im DocumentFragment liegen
        await preloadImages(fragment);

        // 2. Erst einfügen, wenn die Bilder im Browser-Cache sind
        currentGrid.appendChild(fragment);
      }

      // Pagination-Link im DOM aktualisieren
      const newNextLink = doc.querySelector('.pagination__item.push-btn.ml-auto') || doc.querySelector('a[rel="next"]');
      const currentNextLink = document.querySelector('.pagination__item.push-btn.ml-auto') || document.querySelector('a[rel="next"]');

      if (newNextLink && currentNextLink) {
        currentNextLink.href = newNextLink.href;
      } else {
        noMorePages = true;
        if (observer) observer.disconnect();
        const container = document.getElementById('infinite-scroll-container');
        if (container) container.remove();
        const pagination = document.querySelector('nav.pagination');
        if (pagination) pagination.remove();
      }

    } catch (err) {
      console.error('[InfiniteScroll] Fehler:', err);
    } finally {
      isLoading = false;
      hideLoader();
    }
  }

  function init() {
    const path = window.location.pathname;
    if (!path.includes('/collections/') && !path.includes('/search')) return;
    if (!getNextPageUrl()) { noMorePages = true; return; }

    hidePagination();
    setupContainer();

    if (!sentinel) return;

    // IntersectionObserver initialisieren
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    }, { rootMargin: `0px 0px ${LOAD_THRESHOLD}px 0px` });

    observer.observe(sentinel);
    console.log('[InfiniteScroll] Optimiert initialisiert ✓');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > lastScrollY && currentScrollY > 80) {
          header.classList.add('header--hidden');
        } else {
          header.classList.remove('header--hidden');
        }

        lastScrollY = currentScrollY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

